module.exports = "/images/Entertaiment Center.svg?2d937faec1cee0ee7eb1dfffff5bf66b";